export default "__VITE_ASSET__CbM0$YuH__"